import { toTimestamp, useGraphCtx } from '@mi-front/core';
import { DurationForRange, StreamEl } from '@mi-front/ui';
import moment from 'moment-timezone';
import { transparentize } from 'polished';
import { DisplayableChunk } from '../../../../../../fragments/types';
import { ChunksRangeConverter } from '../../../../../../joint-fragments/helpers/chunks-range-converter';
import { useHoveredTs } from '../../../components/focus/hovered-ts-ctx';
import { useFragmentEditorStore } from '../../stores/useFragmentEditorStore';
import { EditorChunkLabelWrapper } from './EditorChunkLabelWrapper';

import { FormattedMessage } from 'react-intl';
export function FocusEditorChunks() {
  const { height } = useGraphCtx();
  const fragment = useFragmentEditorStore((state) => state.fragment);
  const hoveredTs = useHoveredTs();

  if (!fragment) {
    return null;
  }

  const converter = new ChunksRangeConverter(fragment.chunks);

  const hoveredChunk = fragment.chunks.find(
    (c) => hoveredTs && c === converter.getChunkForRealTs(hoveredTs),
  );

  return (
    <>
      {fragment.chunks.map((chunk, index) => (
        <StreamEl
          key={chunk.from}
          ts={toTimestamp(chunk.from)}
          position="bottom"
          fullHeight
          zIndex={2}
          style={{
            pointerEvents: 'none',
          }}
        >
          {(scale) => {
            const width = scale(toTimestamp(chunk.to))! - scale(toTimestamp(chunk.from))!;

            return (
              <EditorChunkLabelWrapper
                bgColor={chunk.color}
                style={{
                  position: 'absolute',
                  top: 4,
                  left: 4,
                  zIndex: 1,
                  minWidth: width,
                  transition: 'opacity .2s',
                  opacity: hoveredChunk === chunk ? 1 : 0,
                }}
              >
                <small className="font-weight-bold">
                  <EditorChunkLabel index={index} chunk={chunk} />
                </small>
                {' - '}
                <small>
                  {moment(chunk.from).format('HH:mm:ss')} (
                  <DurationForRange from={chunk.from} to={chunk.to} />)
                </small>
              </EditorChunkLabelWrapper>
            );
          }}
        </StreamEl>
      ))}
      {fragment.chunks.map((chunk, index) => (
        <StreamEl
          key={chunk.from}
          ts={toTimestamp(chunk.from)}
          position="bottom"
          fullHeight
          style={{
            pointerEvents: 'none',
          }}
        >
          {(scale) => {
            const width = scale(toTimestamp(chunk.to))! - scale(toTimestamp(chunk.from))!;
            return (
              <div
                style={{
                  position: 'absolute',
                  backgroundColor: transparentize(0.6, chunk.color),
                  height,
                  width,
                }}
              />
            );
          }}
        </StreamEl>
      ))}
    </>
  );
}

export function EditorChunkLabel({ chunk, index }: { chunk: DisplayableChunk; index: number }) {
  return (
    <span>
      {chunk.label || (
        <span style={{ fontStyle: 'italic' }}>
          <FormattedMessage id="jointFragments.props.chunk" defaultMessage="Segmento" /> #
          {index + 1}
        </span>
      )}
    </span>
  );
}
